var render = function render(){var _vm=this,_c=_vm._self._c;return _c('as-detail-comp',{attrs:{"workorder-id":_vm.workorderId}})
}
var staticRenderFns = []

export { render, staticRenderFns }